import {
    Modal,
    Form,
    Input,
    Button,
    Row,
    Col,
    Descriptions,
    Tabs,
    Space,
} from 'antd';
import { useState, useEffect } from 'react';
import { getPlanVariables, testConcept } from '../../../api/payments';
import TableConditions from './TableConditions';
import TableOperations from './TableOperations';
import { IConcept, IConceptEval, IVariable } from '../../../interfaces/plan';
import CodeDisplay from './CodeDisplay';

interface IConceptEvalModal {
    visible: boolean;
    concept: IConcept;
    onCancel: () => void;
}

const ConceptEvalModal = ({
    visible,
    concept,
    onCancel,
}: IConceptEvalModal) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [conceptEval, setConceptEval] = useState<IConceptEval>();
    const [variables, setVariables] = useState<IVariable[]>([]);

    const handleTest = (values: any) => {
        setLoading(true);
        testConcept(concept.planID, concept._id, values)
            .then(({ data }) => {
                setConceptEval(data.data);
            })
            .catch()
            .finally(() => setLoading(false));
    };

    const fetchPlanVariables = (planID: string) => {
        setLoading(true);
        getPlanVariables(planID)
            .then(({ data }) => setVariables(data.data))
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    };

    const items = [
        {
            label: 'Conditions',
            key: 'CONDITIONS',
            children: (
                <TableConditions
                    conditions={conceptEval?.conditions || []}
                    loading={loading}
                />
            ),
        },
        {
            label: 'Operations',
            key: 'OPERATIONS',
            children: (
                <TableOperations
                    conceptEval={conceptEval as IConceptEval}
                    concept={concept}
                    variables={variables}
                    loading={loading}
                />
            ),
        },
    ];

    const handleCancel = () => {
        setConceptEval(undefined);
        setVariables([]);
        form.resetFields();
        onCancel();
    };

    useEffect(() => {
        if (!concept) return;
    }, [concept, form]);

    useEffect(() => {
        if (!concept) return;
        fetchPlanVariables(concept.planID);
    }, [concept]);

    return (
        <Modal
            title={`Test Concept: ${concept?.name}`}
            visible={visible}
            width={1000}
            onCancel={handleCancel}
        >
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <Form form={form} layout="vertical" onFinish={handleTest}>
                    <Row gutter={3}>
                        <Col span={20}>
                            <Form.Item label="Booking" name="bookingId">
                                <Input placeholder="888888888" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                <Button type="primary" block htmlType="submit" loading={loading}>
                                    Test
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                <CodeDisplay code={concept?.operation} />

                <Tabs items={items} />

                <Descriptions title="Result" bordered column={1}>
                    {conceptEval?.operations?.map((operation: any) => (
                        <Descriptions.Item key={operation.name} label={operation.name}>{operation.amount}</Descriptions.Item>
                    ))}
                    <Descriptions.Item label="Total">{conceptEval?.total || 0}</Descriptions.Item>
                </Descriptions>
            </Space>
        </Modal>
    );
};

export default ConceptEvalModal;
